export const base = {
    PUBLIC_PRE: "",
}

export const publicUser = {
    INITIAL: "/",
    HOME1: "/index",
    HOME2: "/",        // canonical home (was /index2 — kept as a redirect for old links)
    HOME3: "/index3",
    HOME4: "/index4",
    HOME5: "/index5",
    HOME6: "/index6",
    HOME7: "/index7",
    HOME8: "/index8",
    HOME9: "/index9",
    HOME10: "/index10",
    HOME11: "/index11",
    HOME12: "/index12",
    HOME13: "/index13",
    HOME14: "/index14",
    HOME15: "/index15",
    HOME16: "/index16",
    HOME17: "/index17",
    HOME18: "/index18",
    employer: {
        GRID: "/scholarship-grid",
        LIST: "/scholarship-list",

        // Canonical page URL. Slugs replaced numeric ids in the rebuild: an id
        // says nothing to a reader or a search engine, and the ids were
        // reassigned anyway when the table was repopulated.
        DETAIL: "/scholarship/:slug",

        // The URL shape the site shipped with. Kept as a route so old links and
        // anything still in Google's index resolve instead of 404ing — it looks
        // the id up in LegacyRedirect and forwards to whatever replaced it.
        DETAIL1: "/scholarship-detail/:id",
    },
    pages: {
        ERROR404:       "/error404",
        CONTACT:        "/contact-us",
        ABOUT:          "/about-us",
        PRIVACY:        "/privacy-policy",
        TERMS:          "/terms-of-use",
        // How listings are researched, sourced and updated. Public trust page —
        // linked in the footer and listed in the sitemap, not a utility route.
        LISTING_PROCESS: "/scholarship-listing-process",
        MAINTENANCE:    "/under-maintenance",
        ICONS:          "/icons"
    },
    candidate: {
        GRID: "/scholarship-stories",
        DETAIL1: "/scholarship-story-detail/:id",
        SHARE_STORY: "/share-story",
        SHARE_STORY_THANK_YOU: "/share-story/thank-you"
    },
    blog: {
        GRID1: "/blog-grid/1",
        GRID2: "/blog-grid/2",
        GRID3: "/blog-grid/3",
        LIST: "/blog-list",
        DETAIL: "/blog-detail/:id"
    },
    testPrep: {
        SAT: "/sat-prep",
        SAT_SECTION: "/sat-prep/section/:id",
        SAT_SKILL: "/sat-prep/skill/:id",
        SAT_PROGRESS: "/sat-prep/my-progress",
        SAT_LOGIN: "/sat-prep/log-in",
        SAT_SIGNUP: "/sat-prep/create-account"
    }
}

export function pubRoute(_route) {
    return base.PUBLIC_PRE + _route;
}

/**
 * The URL for a scholarship or hub page.
 *
 * Every link to a scholarship goes through here — there were nine places
 * building `DETAIL1.replace(':id', item.id)` by hand, which is exactly how a
 * URL scheme ends up half migrated.
 *
 * Falls back to the legacy id URL when an item has no slug, so a page rendered
 * from a stale cache still links somewhere that resolves.
 */
export function scholarshipUrl(item) {
    if (!item) return publicUser.employer.LIST;
    if (item.slug) return publicUser.employer.DETAIL.replace(":slug", item.slug);
    return publicUser.employer.DETAIL1.replace(":id", item.id);
}
